import { render } from "./WorkshiftsHistory.vue?vue&type=template&id=058c6f42"
import script from "./WorkshiftsHistory.vue?vue&type=script&lang=js"
export * from "./WorkshiftsHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__